export default "__VITE_ASSET__CuRUfrSg__"